import React, { useState, useEffect } from "react";
import "../components/Table/Table.css";
import TopLoader from "../components/Loader/TopLoader";
import { useTranslation } from "react-i18next";
import { teacher_profile } from "../api/Users";
import DocumentScannerRoundedIcon from "@mui/icons-material/DocumentScannerRounded";
import DownloadIcon from "@mui/icons-material/Download";
import { Image } from "react-bootstrap";
import { MDBTypography } from "mdb-react-ui-kit";
import { Modal } from "@mui/material";
import multi_img from "../images/multiple_docs.png";
import userImage from "../images/userIcon.png";

const MyProfile = ({ userData }) => {
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const [modalOpen1, setModalOpen1] = useState(false);
  const [filteredData, setFilteredData] = useState([]);
  const [photo, setPhoto] = useState(null);
  const [imageSrc, setImageSrc] = useState("");
  const [edit, setEdit] = useState(false);
  const [modalOpen, setModalOpen] = useState(false);
  const [error, setErrors] = useState({});
  const [markRequired, setMarkRequired] = useState(true);
  const [staff, setStaff] = useState({
    name: "",
    father_name: "",
    post: "",
    date_of_birth: "",
    category: "",
    gender: "",
    doj: "",
    HRMS_id: "",
    phone_number: "",
    category_of_school: "",
    ddo: "",
    staff_aadhaar: "",
    staff_pan: "",
    highest_qualification: "",
    tenth_qualification: "",
    twelveth_qualification: "",
  });
  const [isShowDocumentClick, setIsShowDocumentClick] = useState(false);

  console.log(filteredData);

  const handleUpdateClick1 = (row) => {
    setModalOpen1(true);
  };

  useEffect(() => {
    const fetchData = async () => {
      teacher_profile({ teacher_id: userData.data.teacher_id }).then((res) => {
        setIsLoading(true);
        if (res.status === "success") {
          setFilteredData(res.data);
          setImageSrc(`data:image/jpeg/png/jpg;base64, ${res.data[0]?.image}`);
        }
        setIsLoading(false);
      });
    };
    fetchData();
  }, [userData]);

  const HandleOnEditUserDetails = (ev) => {
    setModalOpen(true);
  };

  const handleCloseModal = () => {
    setModalOpen(false);
  };
  const handleCloseModal1 = () => {
    setModalOpen1(false);
    setIsShowDocumentClick(false);
  };
  const handlePhotoChange = (event) => {
    const file = event.target.files[0];
    setPhoto(file);
  };

  const handleChangeInput = (e) => {
    const { name, value, type, files } = e.target;
    if (type !== "file") {
      setStaff((student) => ({ ...student, [name]: value }));
    } else {
      const file = files[0];
      setStaff((student) => ({ ...student, [name]: file }));
    }
  };

  const formatDate = (dateStr) => {
    const parts = dateStr?.split("-");
    if (parts?.length === 3) {
      let date = `${parts[0]}-${parts[1]}-${parts[2]}`;
      console.log(date);
      return date;
    }
    return "";
  };

  const HandleOnShowDocument = (e) => {
    setIsShowDocumentClick(true);
  };

  const onSubmit = (e) => {
    e.preventDefault();
    const form = e.target; 
    console.log(form)
    const formData = {};
    for (let field of form.elements) {
        if (field.name) {
            formData[field.name] = field.value;
        }
    }
    console.log(formData);
    //   const namePattern = /^[a-zA-Z\s'-\.]+$/;
    //   if (photo == null && !selectedRow.teacher_photo) {
    //     formErrors.photo_file = "No Staff photo selected!";
    //   }
    //   if (!staff.name.trim() && !selectedRow.teacher_name.trim()) {
    //     formErrors.name = "Staff Name is required";
    //   } else if (
    //     staff.name
    //       ? !namePattern.test(staff.name)
    //       : !namePattern.test(selectedRow.teacher_name)
    //   ) {
    //     formErrors.name = " Staff name must contain only letters";
    //   }
    //   if (!staff.father_name.trim() && !selectedRow.father_name.trim()) {
    //     formErrors.father_name = "Father's Name is required";
    //   } else if (
    //     staff.father_name
    //       ? !namePattern.test(staff.father_name)
    //       : !namePattern.test(selectedRow.father_name)
    //   ) {
    //     formErrors.father_name = "Father's Name must contain only letters";
    //   }
    //   if (!staff.post.trim() && !selectedRow.Category_of_post_held) {
    //     formErrors.post = "Post is required";
    //   } else if (
    //     staff.post
    //       ? !namePattern.test(staff.post)
    //       : !namePattern.test(selectedRow.Category_of_post_held)
    //   ) {
    //     formErrors.post = "Post must contain only letters";
    //   }
    //   if (!staff.gender && !selectedRow.Gender) {
    //     formErrors.gender = "Gender is required";
    //   }
    //   if (!staff.date_of_birth && !selectedRow.DOB) {
    //     formErrors.date_of_birth = "Date of Birth is required";
    //   }
    //   if (!staff.category && !selectedRow.Category) {
    //     formErrors.category = "Category is required";
    //   }
    //   if (!staff.doj && !selectedRow.Date_of_Joining_in_the_present_post) {
    //     formErrors.doj = "Date Of Joining is required";
    //   }
    //   if (!staff.HRMS_id && !selectedRow.HRMS_ID) {
    //     formErrors.HRMS_id = "HRMS ID is required";
    //   }
    //   if (!staff.phone_number && !selectedRow.teacher_contact_no) {
    //     formErrors.phone_number = "Phone Number is required";
    //   }
    //   if (!staff.ddo && !selectedRow.Name_of_DDO) {
    //     formErrors.ddo = "DDO is required";
    //   }
    //   if (!staff.category_of_school && !selectedRow.Category_of_school) {
    //     formErrors.category_of_school = "Category Of Schhol is required";
    //   }
    //   if (
    //     !staff.staff_aadhaar == null ||
    //     !staff.staff_pan == null ||
    //     !staff.student_aadhaar == null
    //   ) {
    //     toast.error("Documents upload pending!");
    //   }
    //   setErrors(formErrors);
    //   if (Object.keys(formErrors).length === 0) {
    //     setIsLoading(true);
    //     const formData = new FormData();
    //     formData.append("school_id", userData.data.school_id);
    //     formData.append("district_code", userData.data.district_code);
    //     formData.append(
    //       "teacher_name",
    //       staff.name ? staff.name : selectedRow.teacher_name
    //     );
    //     formData.append(
    //       "post",
    //       staff.post ? staff.post : selectedRow.Category_of_post_held
    //     );
    //     formData.append(
    //       "date_of_birth",
    //       staff.date_of_birth ? staff.date_of_birth : selectedRow.DOB1
    //     );
    //     formData.append(
    //       "category",
    //       staff.category ? staff.category : selectedRow.Category
    //     );
    //     formData.append(
    //       "gender",
    //       staff.gender ? staff.gender : selectedRow.Gender
    //     );
    //     formData.append(
    //       "father_name",
    //       staff.father_name ? staff.father_name : selectedRow.father_name
    //     );
    //     formData.append(
    //       "joining_date",
    //       staff.doj ? staff.doj : selectedRow.Date_of_Joining_in_the_present_post1
    //     );
    //     formData.append(
    //       "DDO_name",
    //       staff.ddo ? staff.ddo : selectedRow.Name_of_DDO
    //     );
    //     formData.append(
    //       "category_of_school",
    //       staff.category_of_school
    //         ? staff.category_of_school
    //         : selectedRow.Category_of_school
    //     );
    //     formData.append(
    //       "teacher_contact_no",
    //       staff.phone_number ? staff.phone_number : selectedRow.teacher_contact_no
    //     );
    //     formData.append(
    //       "hrms_id",
    //       staff.HRMS_id ? staff.HRMS_id : selectedRow.HRMS_ID
    //     );
    //     formData.append(
    //       "teacher_aadhar_card",
    //       staff.staff_aadhaar
    //         ? staff.staff_aadhaar
    //         : selectedRow.teacher_aadhar_card
    //     );
    //     formData.append(
    //       "teacher_qualification",
    //       staff.highest_qualification
    //         ? staff.highest_qualification
    //         : selectedRow.teacher_qualification
    //     );
    //     formData.append(
    //       "teacher_pan_card",
    //       staff.staff_pan ? staff.staff_pan : selectedRow.teacher_pan_card
    //     );
    //     formData.append(
    //       "teacher_photo",
    //       photo ? photo : selectedRow.teacher_photo
    //     );
    //     formData.append(
    //       "teacher_tenth_qualification",
    //       staff.tenth_qualification
    //         ? staff.tenth_qualification
    //         : selectedRow.tenth_qualification
    //     );
    //     formData.append(
    //       "teacher_twelveth_qualification",
    //       staff.twelveth_qualification
    //         ? staff.twelveth_qualification
    //         : selectedRow.twelveth_qualification
    //     );
    //     formData.append("id", staffid);
    //     updateStaff(formData)
    //       .then((res) => {
    //         if (res.status === "success") {
    //           setIsLoading(false);
    //           toast.success(t(res.message));
    //           window.location.reload();
    //         } else {
    //           setIsLoading(false);
    //           toast.error(t(res));
    //         }
    //       })
    //       .catch((err) => {
    //         console.log(err);
    //       });
    //   }
  };

  function openPDFInNewTab(base64String) {
    const decodedData = window.atob(base64String);
    const uint8Array = new Uint8Array(decodedData.length);
    console.log(decodedData.length);
    for (let i = 0; i < decodedData.length; i++) {
      uint8Array[i] = decodedData.charCodeAt(i);
    }
    const blob = new Blob([uint8Array], { type: "application/pdf" });
    const url = URL.createObjectURL(blob);
    window.open(url, "_blank");
  }

  return (
    <>
      <TopLoader loading={isLoading ? "50" : "100"} />
      <div className="row col-12 d-flex justify-content-center mt-5 bg-white">
        {/* <div className="construction"></div> */}
      </div>
      <div className="px-0 px-md-3">
        <div className="my-4 col-12 d-flex justify-content-between align-items-center">
          <div>
            <h5 className="">{t("Profile")}</h5>
          </div>
          <div>
            <button
              className="btn btn-outline-primary me-3"
              onClick={HandleOnEditUserDetails}
            >
              Edit Profile
            </button>
            {/* <button
              className="btn btn-outline-primary me-2"
              onClick={HandleOnShowDocument}
            >
              Show Documents
            </button> */}
          </div>
        </div>
        <div className="container d-flex justify-content-between">
          <div className="card mb-3" style={{ maxWidth: "55%" }}>
            <div className="row g-0">
              <div className="col-md-4">
                <img
                  src={filteredData[0]?.image?imageSrc:userImage}
                  className="img-fluid rounded-start"
                  style={{ width: "fit-content", height: "fit-content", padding: "10px" }}
                  alt='user Icon'
                />
              </div>
              <div className="col-md-8">
                <div className="card-body">
                  <ul className="list">
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Name:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.teacher_name}
                        </span>
                      </section>
                    </li>
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">HRMS ID:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>{filteredData[0]?.additionalData.HRMS_ID}</span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Gender:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>{filteredData[0]?.additionalData.Gender}</span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Post:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {
                            filteredData[0]?.additionalData
                              .Category_of_post_held
                          }
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Village Name:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.Village_name}
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">
                          Date of Joining (Present Post):
                        </strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {
                            filteredData[0]?.additionalData
                              .Date_of_Joining_in_the_present_post
                          }
                        </span>
                      </section>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
          <div className="card mb-3" style={{ maxWidth: "40%" }}>
            <div className="row g-0">
              <div className="col-md-12">
                <div className="card-body">
                  <ul className="list">
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Contact Number:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.teacher_contact_no?filteredData[0]?.additionalData.teacher_contact_no:"N/a"}
                        </span>
                      </section>
                    </li>
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Date of Birth:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>{filteredData[0]?.additionalData.DOB}</span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Father's Name:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.father_name}
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Category of school:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.Category_of_school}
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Name of DDO:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.Name_of_DDO}
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">School Name:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          {filteredData[0]?.additionalData.school_name}
                        </span>
                      </section>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div>
        {/* <div className="container d-flex justify-content-between">
          <div className="card mb-3" style={{ maxWidth: "100%" }}>
            <div className="row g-0">
              <div className="col-md-12">
                <div className="card-body">
                  <ul className="list">
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">Adhar Card:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          <DocumentScannerRoundedIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openPDFInNewTab(filteredData[0]?.teacher_aadhar)
                            }
                          />
                        </span>
                      </section>
                    </li>
                    <li className="list-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">PAN Card:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          <DocumentScannerRoundedIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openPDFInNewTab(filteredData[0]?.teacher_pan_card)
                            }
                          />
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">
                          Teacher's Highest Qualification:
                        </strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          <DocumentScannerRoundedIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openPDFInNewTab(
                                filteredData[0]?.teacher_highest_qualification
                              )
                            }
                          />
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">10th Qualification:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          <DocumentScannerRoundedIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openPDFInNewTab(
                                filteredData[0]?.tenth_qualification
                              )
                            }
                          />
                        </span>
                      </section>
                    </li>
                    <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                      <section style={{ width: "50%" }}>
                        <strong className="me-4">12th Qualification:</strong>
                      </section>
                      <section style={{ width: "50%" }}>
                        <span>
                          <DocumentScannerRoundedIcon
                            style={{ cursor: "pointer" }}
                            onClick={() =>
                              openPDFInNewTab(
                                filteredData[0]?.twelveth_qualification
                              )
                            }
                          />
                        </span>
                      </section>
                    </li>
                  </ul>
                </div>
              </div>
            </div>
          </div>
        </div> */}
        <div class="container">
          <table class="table">
            <tbody>
              <tr>
                <td>
                  <strong>Adhar Card:</strong>
                </td>
                <td>
                  <span>
                    {/* <DocumentScannerRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.teacher_aadhar)
                      }
                    /> */}
                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.teacher_aadhar)
                      }
                    >
                      <DownloadIcon className="me-1" />
                      Download
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>PAN Card:</strong>
                </td>
                <td>
                  <span>
                    {/* <DocumentScannerRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.teacher_pan_card)
                      }
                    /> */}
                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.teacher_pan_card)
                      }
                    >
                      <DownloadIcon className="me-1" />
                      Download
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>Teacher's Highest Qualification:</strong>
                </td>
                <td>
                  <span>
                    {/* <DocumentScannerRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        openPDFInNewTab(
                          filteredData[0]?.teacher_highest_qualification
                        )
                      }
                    /> */}
                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        openPDFInNewTab(
                          filteredData[0]?.teacher_highest_qualification
                        )
                      }
                    >
                      <DownloadIcon className="me-1" />
                      Download
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>10th Qualification:</strong>
                </td>
                <td>
                  <span>
                    {/* <DocumentScannerRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.tenth_qualification)
                      }
                    /> */}
                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.tenth_qualification)
                      }
                    >
                      <DownloadIcon className="me-1" />
                      Download
                    </button>
                  </span>
                </td>
              </tr>
              <tr>
                <td>
                  <strong>12th Qualification:</strong>
                </td>
                <td>
                  <span>
                    {/* <DocumentScannerRoundedIcon
                      style={{ cursor: "pointer" }}
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.twelveth_qualification)
                      }
                    /> */}
                    <button
                      className="btn btn-secondary"
                      onClick={() =>
                        openPDFInNewTab(filteredData[0]?.twelveth_qualification)
                      }
                    >
                      <DownloadIcon className="me-1" />
                      Download
                    </button>
                  </span>
                </td>
              </tr>
            </tbody>
          </table>
        </div>

        {/* Modal click on edit profile button */}
        <Modal
          open={modalOpen}
          onClose={handleCloseModal}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 1280,
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
              height: 500,
              overflowY: "scroll",
            }}
          >
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <MDBTypography tag="h5" className="">
                  {t("Update Staff Details")}
                </MDBTypography>
              </div>
            </div>
            <div className="row">
              <form
                onSubmit={(e) => onSubmit(e)}
                id="myform"
                style={{ marginTop: "12px" }}
              >
                <div className="row">
                  <div className="col-md-4">
                    <label className="form-label">{t("Staff Photo")}</label>
                    <input
                      type="file"
                      name="photo_file"
                      accept="image/*"
                      className="form-control"
                      onChange={handlePhotoChange}
                    />
                    {error.photo_file && (
                      <div className="text-danger">{error.photo_file}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Staff Name")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="name"
                      className="form-control"
                      defaultValue={
                        filteredData[0]?.additionalData.teacher_name
                      }
                      onChange={handleChangeInput}
                      required
                    />
                    {error.name && (
                      <div className="text-danger">{error.name}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Father Name")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="father_name"
                      defaultValue={filteredData[0]?.additionalData.father_name}
                      className="form-control"
                      onChange={handleChangeInput}
                      required
                    />
                    {error.father_name && (
                      <div className="text-danger">{error.father_name}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Post")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="post"
                      className="form-control"
                      defaultValue={
                        filteredData[0]?.additionalData.Category_of_post_held
                      }
                      onChange={handleChangeInput}
                      required
                    />
                    {error.post && (
                      <div className="text-danger">{error.post}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Date of Birth")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="date"
                      name="date_of_birth"
                      className="form-control"
                      defaultValue={formatDate(
                        filteredData[0]?.additionalData.DOB
                      )}
                      onChange={handleChangeInput}
                      required
                    />
                    {error.date_of_birth && (
                      <div className="text-danger">{error.date_of_birth}</div>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Category")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="category"
                      defaultValue={filteredData[0]?.additionalData.Category}
                      className="form-control"
                      onChange={handleChangeInput}
                      required
                    />
                    {error.category && (
                      <div className="text-danger">{error.category}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Gender")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <select
                      name="gender"
                      onChange={handleChangeInput}
                      className="common-input form-select"
                      required
                      defaultValue={filteredData[0]?.additionalData.Gender}
                    >
                      <option value="">{t("Select Gender")}</option>
                      <option value="Male">Male</option>
                      <option value="Female">Female</option>
                    </select>
                    {error.gender && (
                      <div className="text-danger">{error.gender}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">{t("Date Of Joining")}</label>
                    <input
                      type="date"
                      className="form-control"
                      name="doj"
                      onChange={handleChangeInput}
                      value={formatDate(
                        filteredData[0]?.additionalData
                          .Date_of_Joining_in_the_present_post
                      )}
                      required
                    ></input>
                    {error.doj && (
                      <div className="text-danger">{error.doj}</div>
                    )}
                  </div>

                  <div className="col-md-4">
                    <label className="form-label">
                      {t("HRMS ID")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="hrms_id"
                      className="form-control"
                      onChange={handleChangeInput}
                      defaultValue={filteredData[0]?.additionalData.HRMS_ID}
                      required
                    />
                    {error.HRMS_id && (
                      <div className="text-danger">{error.HRMS_id}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Phone Number")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      onChange={handleChangeInput}
                      type="text"
                      pattern="[0-9]*"
                      maxLength={10}
                      minLength={10}
                      name="phone_number"
                      className="form-control"
                      defaultValue={
                        filteredData[0]?.additionalData.teacher_contact_no
                      }
                      required
                    />
                    {error.phone_number && (
                      <div className="text-danger">{error.phone_number}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Category Of School")}{" "}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="category_of_school"
                      className="form-control"
                      onChange={handleChangeInput}
                      defaultValue={
                        filteredData[0]?.additionalData.Category_of_school
                      }
                      required
                    />
                    {error.category_of_school && (
                      <div className="text-danger">
                        {error.category_of_school}
                      </div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label">
                      {t("Name Of DDO")}
                      {markRequired && <span style={{ color: "red" }}>*</span>}
                    </label>
                    <input
                      type="text"
                      name="ddo"
                      defaultValue={filteredData[0]?.additionalData.Name_of_DDO}
                      className="form-control"
                      onChange={handleChangeInput}
                      required
                    />
                    {error.ddo && (
                      <div className="text-danger">{error.ddo}</div>
                    )}
                  </div>
                  <div className="col-md-4">
                    <label className="form-label mt-3">
                      {t("Add Documents (PDF only)")}{" "}
                    </label>
                    <div className="">
                      <button
                        type="button"
                        className="btn btn-secondary col-md-8"
                        onClick={handleUpdateClick1}
                      >
                        {t("Add")}
                      </button>
                    </div>
                  </div>
                </div>
                <div className="row col-12 mt-5 d-flex justify-content-end">
                  <button
                    type="submit"
                    className="btn btn-primary mx-1 mt-4 btn-sm col-2"
                  >
                    {t("Update")}
                  </button>
                  <button
                    className="btn btn-secondary mx-1 mt-4 btn-sm col-2"
                    onClick={handleCloseModal}
                  >
                    {t("Close")}
                  </button>
                </div>
              </form>
            </div>
          </div>
        </Modal>
        {/* Modal click on Add document button */}
        <Modal
          open={modalOpen1}
          onClose={handleCloseModal1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 1100,
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
            }}
          >
            {" "}
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal1}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
            <div className="row mt-4 mb-2">
              <div className="row">
                <div className="col-6 d-flex justify-content-center">
                  <Image src={multi_img} height="300px" />
                </div>
                <div className="col-6">
                  <div className="d-flex justify-content-between align-items-center">
                    <div>
                      <MDBTypography tag="h5" className="mb-4">
                        {t("Add Documents (PDF only)")}
                      </MDBTypography>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-md-6">
                      <label className="form-label my-3">
                        {t("Staff Aadhaar")}
                      </label>
                      <input
                        type="file"
                        name="staff_aadhaar"
                        accept=".pdf"
                        className="form-control"
                        onChange={handleChangeInput}
                      />
                      {staff.staff_aadhaar && (
                        <p className="text-primary">
                          {t("Selected file")}: {staff.staff_aadhaar.name}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label my-3">
                        {t("Staff Pan Card")}
                      </label>
                      <input
                        type="file"
                        name="staff_pan"
                        accept=".pdf"
                        className="form-control"
                        onChange={handleChangeInput}
                      />
                      {staff.staff_pan && (
                        <p className="text-primary">
                          {t("Selected file")}: {staff.staff_pan.name}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label my-3">
                        {t("10th Certificate")}
                      </label>
                      <input
                        type="file"
                        name="tenth_qualification"
                        accept=".pdf"
                        className="form-control"
                        onChange={handleChangeInput}
                      />
                      {staff.highest_qualification && (
                        <p className="text-primary">
                          {t("Selected file")}: {staff.ten_Cert.name}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label my-3">
                        {t("12th Certificate")}
                      </label>
                      <input
                        type="file"
                        name="twelveth_qualification"
                        accept=".pdf"
                        className="form-control"
                        onChange={handleChangeInput}
                      />
                      {staff.highest_qualification && (
                        <p className="text-primary">
                          {t("Selected file")}: {staff.twe_Cert.name}
                        </p>
                      )}
                    </div>
                    <div className="col-md-6">
                      <label className="form-label my-3">
                        {t("Highest Qualification")}
                      </label>
                      <input
                        type="file"
                        name="highest_qualification"
                        accept=".pdf"
                        className="form-control"
                        onChange={handleChangeInput}
                      />
                      {staff.highest_qualification && (
                        <p className="text-primary">
                          {t("Selected file")}:{" "}
                          {staff.highest_qualification.name}
                        </p>
                      )}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal>
        {/* <Modal
          open={isShowDocumentClick}
          onClose={handleCloseModal1}
          aria-labelledby="modal-modal-title"
          aria-describedby="modal-modal-description"
        >
          <div
            style={{
              position: "absolute",
              top: "50%",
              left: "50%",
              transform: "translate(-50%, -50%)",
              width: 500,
              backgroundColor: "#ffffff",
              boxShadow: "0px 4px 8px rgba(0, 0, 0, 0.1)",
              borderRadius: 8,
              padding: 20,
              height: 300,
              // overflowY: "scroll",
            }}
          >
            <button
              type="button"
              className="btn-close"
              aria-label="Close"
              onClick={handleCloseModal1}
              style={{
                position: "absolute",
                top: 10,
                right: 10,
                background: "none",
                border: "none",
                fontSize: 24,
                cursor: "pointer",
              }}
            >
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="24"
                height="24"
                fill="currentColor"
                className="bi bi-x"
                viewBox="0 0 16 16"
              >
                <path d="M3.854 3.146a.5.5 0 0 1 .708 0L8 7.293l3.646-3.647a.5.5 0 1 1 .708.708L8.707 8l3.647 3.646a.5.5 0 1 1-.708.708L8 8.707l-3.646 3.647a.5.5 0 1 1-.708-.708L7.293 8 3.646 4.354a.5.5 0 0 1 0-.708z" />
              </svg>
            </button>
            <div className="d-flex justify-content-between align-items-center">
              <div>
                <MDBTypography tag="h5" className="">
                  {t("Documents")}
                </MDBTypography>
              </div>
            </div>
            <div className="container" style={{ maxWidth: "100%" }}>
              <div className="card mb-3" style={{ maxWidth: "100%" }}>
                <div className="row g-0">
                  <div className="container d-flex justify-content-between">
                    <div className="card mb-3" style={{ maxWidth: "100%" }}>
                      <div className="row g-0">
                        <div className="col-md-12">
                          <div className="card-body">
                            <ul className="list">
                              <li className="list-item d-flex justify-content-between align-items-center mb-2">
                                <section style={{ width: "70%" }}>
                                  <strong className="me-4">Adhar Card:</strong>
                                </section>
                                <section style={{ width: "30%" }}>
                                  <span>
                                    <DocumentScannerRoundedIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        openPDFInNewTab(
                                          filteredData[0]?.teacher_aadhar
                                        )
                                      }
                                    />
                                  </span>
                                </section>
                              </li>
                              <li className="list-item d-flex justify-content-between align-items-center mb-2">
                                <section style={{ width: "70%" }}>
                                  <strong className="me-4">PAN Card:</strong>
                                </section>
                                <section style={{ width: "30%" }}>
                                  <span>
                                    <DocumentScannerRoundedIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        openPDFInNewTab(
                                          filteredData[0]?.teacher_pan_card
                                        )
                                      }
                                    />
                                  </span>
                                </section>
                              </li>
                              <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                <section style={{ width: "70%" }}>
                                  <strong className="me-4">
                                    Teacher's Highest Qualification:
                                  </strong>
                                </section>
                                <section style={{ width: "30%" }}>
                                  <span>
                                    <DocumentScannerRoundedIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        openPDFInNewTab(
                                          filteredData[0]
                                            ?.teacher_highest_qualification
                                        )
                                      }
                                    />
                                  </span>
                                </section>
                              </li>
                              <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                <section style={{ width: "70%" }}>
                                  <strong className="me-4">
                                    10th Qualification:
                                  </strong>
                                </section>
                                <section style={{ width: "30%" }}>
                                  <span>
                                    <DocumentScannerRoundedIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        openPDFInNewTab(
                                          filteredData[0]?.tenth_qualification
                                        )
                                      }
                                    />
                                  </span>
                                </section>
                              </li>
                              <li className="list-group-item d-flex justify-content-between align-items-center mb-2">
                                <section style={{ width: "70%" }}>
                                  <strong className="me-4">
                                    12th Qualification:
                                  </strong>
                                </section>
                                <section style={{ width: "30%" }}>
                                  <span>
                                    <DocumentScannerRoundedIcon
                                      style={{ cursor: "pointer" }}
                                      onClick={() =>
                                        openPDFInNewTab(
                                          filteredData[0]
                                            ?.twelveth_qualification
                                        )
                                      }
                                    />
                                  </span>
                                </section>
                              </li>
                            </ul>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </Modal> */}
      </div>
    </>
  );
};

export default MyProfile;
